import {
  FaFacebookSquare,
  FaInstagram,
  FaLinkedin,
  FaTelegram,
} from "react-icons/fa";
import React from "react";
import { Link } from "react-router-dom";

export const Footer = () => {
  return (
    <>
      <footer className="bg-dark text-white pt-5">
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-4">
              <h3>About WDSchool</h3>
              <hr />
              <p className="text-secondary ">
                {" "}
                Web Development School is a unique e-learning website, offers a
                tutorial of different popular programming languages with
                examples. The code on this popular tutorial website is tested
                and executed.
              </p>
            </div>
            <div className="col-md-4">
              <h3>Training In WDSchool</h3>
              <hr />
              <ul className=" text-secondary">
                <li>
                  {" "}
                  <Link
                    className="dropdown-item text-light "
                    to="/Pythontrainning"
                  >
                    Python Trainning
                  </Link>
                </li>
                <li>
                  {" "}
                  <Link
                    className="dropdown-item text-light "
                    to="/Nodetrainning"
                  >
                    NodeJs Trainning
                  </Link>
                </li>
                <li>Html Training Course</li>
                <li>Javascript Training Course</li>

                <li>Java Training Course in Delhi</li>
                <li>Data Analytics Training in Delhi</li>

                <li>Linux Training Course in Delhi</li>
              </ul>
            </div>
            <div className="col-md-4">
              <h3 style={{ marginLeft: "90px" }}>
                Web Development
                <span style={{ color: "chocolate" }}> School</span>
              </h3>

              <ul className="list-unstyled text-secondary  text-md-end mt-5">
                <li>SECTOR 16,NOIDA - SOUTH EX. - PITAMPURA - GURUGRAM</li>
                <li>
                  WDSchool:{" "}
                  <span style={{ color: "chocolate" }}>99-10-93-50-66</span>
                </li>
                <li>
                  {" "}
                  Learn Coding With{" "}
                  <span style={{ color: "chocolate" }}> Rahul Katoch </span>
                </li>
              </ul>
            </div>
          </div>
          <hr />

          <div className="row">
            <div className="col-md-3 mt-5">
              <h2> Request a Call Back</h2>
              <h3 style={{ color: "chocolate" }}> 99-10-93-50-66</h3>
            </div>
            <div className="col-md-5  mt-4 d-flex flex-column justify-content-center align-items-center">
              <p className=" pt-1" style={{ backgroundColor: "chocolate" }}>
                {" "}
                Follow Us{" "}
              </p>
              <div style={{ alignItems: "center" }}>
                <a
                  href="https://www.facebook.com/rahul.katoch.9231"
                  style={{ color: "chocolate" }}
                >
                  <FaFacebookSquare />
                </a>

                <a
                  href="https://www.instagram.com/official_rahulkatoch/?igshid=YmMyMTA2M2Y%3D"
                  style={{
                    paddingLeft: "12px",
                    color: "chocolate",
                  }}
                >
                  <FaInstagram />
                </a>

                <a
                  href="www.linkedin.com/in/rahul-katoch-088a7b206"
                  style={{ paddingLeft: "12px", color: "chocolate" }}
                >
                  <FaLinkedin />
                </a>

                <a href="" style={{ paddingLeft: "12px", color: "chocolate" }}>
                  <FaTelegram />
                </a>
              </div>
            </div>

            <div className="col-md-4 mt-5">
              <img
                className="img-fluid"
                src="https://www.kindpng.com/picc/m/48-480088_payment-method-credit-card-master-card-hd-png.png"
                alt="card "
              />
            </div>
          </div>
          <br />
          <div
            className="copyright   py-4 mt-2"
            style={{ backgroundColor: "chocolate" }}
          >
            <div className="container">
              <div className="row">
                <div className="col-md-6">
                  <small>
                    Privacy Policy || Terms of Use || Career || Blog
                  </small>
                </div>
                <div className="col-md-6">
                  <small>
                    © Copyright 2022 Rahul Katoch , All rights reserved.
                  </small>
                </div>
              </div>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};
